function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
export { _arrayLikeToArray as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/arrayLikeToArray.js
// module id = 427
// module chunks = 1